import './app/assets/styles/index.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';

import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from 'react-router-dom';
import { version } from '../package.json';
import { App } from './app/App';

function configSentry() {
	if (process.env.NODE_ENV === 'development') {
		return;
	}

	const dsn = import_meta_env.VITE_SENTRY_DSN;
	const environment = import_meta_env.VITE_SENTRY_ENVIRONMENT;
	if (!dsn || !environment) return;

	Sentry.init({
		release: version,
		dsn,
		environment,
		integrations: [
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect: React.useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
			Sentry.replayIntegration(),
		],
		_experiments: { 
			enableLogs: true
		},
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.0,
		replaysOnErrorSampleRate: 1.0,
	});
}

function configInfiniteWatch() {
	if (!import_meta_env.VITE_INFINITE_WATCH_ENABLED || !import_meta_env.VITE_INFINITE_WATCH_ORGANIZATION_ID) {
		return;
	}

	const script = document.createElement('script');
	script.src = 'https://app.infinitewatch.ai/watch.js';
	script.setAttribute('data-iw-organization-id', import_meta_env.VITE_INFINITE_WATCH_ORGANIZATION_ID);
	script.setAttribute('data-iw-mask-text-selector', "body");
	script.async = true;
	document.head.appendChild(script);
}

console.log(`v${__APP_VERSION__}`);

configSentry();
configInfiniteWatch();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<App />
);
